var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.589fe4f77c7a32cdfe1c0194d195bcf4.svg#s';
                    var viewUrl = 'sprites.589fe4f77c7a32cdfe1c0194d195bcf4.svg#view-s';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 104 36',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };